import {Mental} from "../Mental";
import {ArrayUtils} from "../utils/ArrayUtils";
import {TweenMax} from "gsap";
import {SoundManager} from "../sound/SoundManager";
import {MentalSoundConfig} from "../MentalSoundConfig";
import {MentalHelper} from "../utils/MentalHelper";

export class MentalStickyScatter extends PIXI.Container {
    private _stickScatterPos: number[][] = [];
    private _scatterSpines: PIXI.spine.Spine[] = [];
    private _stickScatterAlreadyPresent: boolean[] = []

    constructor() {
        super();
        this.init();
    }

    public stickScatterOnPos(reelId: number, symbolId: number): void {
        if (symbolId < 0 || this._stickScatterAlreadyPresent[reelId]) {
            return;
        }
        this.createSymbolOverlay(reelId, symbolId)
        this._stickScatterPos.push([reelId, symbolId]);
        this._stickScatterAlreadyPresent[reelId] = true;
    }

    public removeStickyScatteronPos(): void {
        if (!this._stickScatterPos.length) {
            return;
        }
        this._stickScatterPos.forEach((stickyPos: number[], index: number) => {
            Mental.reelArea.getReel(stickyPos[0]).layerSet.removeFromLayer(2, this._scatterSpines[index]);
        });
        this._scatterSpines = [];
        this._stickScatterPos = [];
        this._stickScatterAlreadyPresent = ArrayUtils.initArrayWithValues<boolean>(5, () => false);
    }

    public showStickyScatterOnRestore(reelId: number, symbolId: number): void {
        if (symbolId < 0) {
            return;
        }
        this.createSymbolOverlay(reelId, symbolId);
        this._stickScatterPos.push([reelId, symbolId]);
        this._stickScatterAlreadyPresent[reelId] = true;
    }

    public hideAllOverlayOnReelStop(reelId: number): void {
        for (let i: number = 0; i < this._scatterSpines.length; i++) {
            if (this._stickScatterPos[i][0] === reelId) {
                this._scatterSpines[i].visible = false;
                this._scatterSpines[i].state.setEmptyAnimation(0, 0);
                this._scatterSpines[i].state.clearTracks();
            }
        }
    }

    public showAllOverlayOnBeforeFsReel(): void {
        let chainSoundPlayed: boolean = false;

        this._scatterSpines.forEach((value: PIXI.spine.Spine) => {
            value.visible = true;
            value.updateTransform();
            value.state.setAnimation(0, "Sticky", true);
            TweenMax.fromTo(value, 0.05, {alpha: 0}, {alpha: 1});

            // #334, #332
            if (!chainSoundPlayed) {
                SoundManager.playSoundEffect(MentalSoundConfig.CHAINS[(MentalHelper.getRandomIntInRange(0, 2))]);
                chainSoundPlayed = true;

                Mental.fireFrame.chainSoundPlayed = true;
            }
        });
    }

    private init(): void {
        this._stickScatterAlreadyPresent = ArrayUtils.initArrayWithValues<boolean>(5, () => false);
    }

    private createSymbolOverlay(reelId: number, symbolId: number): void {
        const symbol: PIXI.spine.Spine = new PIXI.spine.Spine(Mental.assetLoader.getSpineAsset("S2")),
            posY: number = (symbolId) ? (symbolId + 2) * 99 : 99,
            s2Lock: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("s2Lock")[0]);

        symbol.position.set(71, posY);
        symbol.visible = false;

        s2Lock.anchor.set(0.5);
        symbol.addChild(s2Lock);

        this._scatterSpines.push(symbol);
        Mental.reelArea.getReel(reelId).layerSet.addToLayer(2, symbol);
    }
}